export default {
  name: '',
  localIpAddress: '',
  publicIpAddress: '',
  accountId: '',
}
